import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  getranke: [],
  loaded: false,
  loading: false,
  error: null
}

// getters
const getters = {
  getranke (state) {
    return state.getranke
  },
  getrank: (state) => (id) => {
    return state.getranke.find(getrank => getrank.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadGetranke ({commit}) {
    commit('setLoading', true)
    console.log('Getränke laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke').orderBy('bezeichnung').get()
    .then(snapshot => {
      const getranke = []
      snapshot.forEach(doc => {
        if (!doc.data().delete) {
          getranke.push({
            ...doc.data(),
            id: doc.id
          })
        }
        commit('setLoadedGetranke', getranke)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createGetrank ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteGetrankData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteGetrank', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateGetrankData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('getranke').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateGetrank', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedGetranke (state, payload) {
    state.getranke = payload
  },
  createGetrank (state, payload) {
    state.getranke.push(payload)
  },
  updateGetrank (state, payload) {
    const getrank = state.getranke.find(getrank => {
      return getrank.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        getrank[key] = payload[key]
      }
    })
  },
  deleteGetrank (state, payload) {
    let array = state.getranke
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.getranke = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/getranke_alt.js